import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack,
  Box, Typography, IconButton, Divider, Alert,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';

import { useApp } from '../context/AppContext';

export default function DialogoRegistroVeci({ abierto, onCerrar }) {
  const { registrarVeci } = useApp();
  const navigate = useNavigate();

  const [datos, setDatos] = useState({
    nombre: '',
    telefono: '',
    direccion: '',
    apodo: '',
    correo: '',
    contrasena: '',
  });
  const [errores, setErrores] = useState({});

  const set = (campo, valor) => {
    setDatos((d) => ({ ...d, [campo]: valor }));
    if (errores[campo]) setErrores((e) => ({ ...e, [campo]: null }));
  };

  const validar = () => {
    const e = {};
    if (!datos.nombre.trim()) e.nombre = 'Falta tu nombre';
    if (!datos.telefono.trim()) e.telefono = 'Falta tu teléfono';
    if (datos.correo && !/^\S+@\S+\.\S+$/.test(datos.correo)) e.correo = 'Correo no válido';
    if (!datos.contrasena || datos.contrasena.length < 6) e.contrasena = 'Mínimo 6 caracteres';
    setErrores(e);
    return Object.keys(e).length === 0;
  };

  const enviar = () => {
    if (!validar()) return;
    registrarVeci(datos);
    navigate('/veci');
    onCerrar();
  };

  return (
    <Dialog open={abierto} onClose={onCerrar} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Typography variant="overline" color="text.secondary">Registrarme como veci</Typography>
          <Typography variant="h5" sx={{ fontFamily: 'Fraunces' }}>
            Regístrate al barrio en HolaVeci
          </Typography>
        </Box>
        <IconButton onClick={onCerrar}><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Alert severity="success" variant="outlined" sx={{ mb: 2.5 }}>
          Para los vecinos la app es <b>gratis</b>. Solo pagas lo que compres en cada negocio.
        </Alert>

        <Stack spacing={2.5}>
          <TextField
            label="Nombre completo"
            placeholder="Ej: Rosa Pérez"
            value={datos.nombre}
            onChange={(e) => set('nombre', e.target.value)}
            error={!!errores.nombre}
            helperText={errores.nombre}
            fullWidth
            autoFocus
          />

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              label="Teléfono / WhatsApp"
              placeholder="300 123 4567"
              value={datos.telefono}
              onChange={(e) => set('telefono', e.target.value)}
              error={!!errores.telefono}
              helperText={errores.telefono}
              sx={{ flex: 1 }}
            />
            <TextField
              label="Cómo te dicen (opcional)"
              placeholder="Doña Rosa"
              value={datos.apodo}
              onChange={(e) => set('apodo', e.target.value)}
              sx={{ flex: 1 }}
            />
          </Stack>

          <TextField
            label="Dirección"
            placeholder="Ej: Cra 33 #45-12, Cabecera"
            value={datos.direccion}
            onChange={(e) => set('direccion', e.target.value)}
            fullWidth
            helperText="Para que los negocios sepan si quedás en su sector"
          />

          <Divider textAlign="left" sx={{ pt: 1 }}>
            <Typography variant="caption" color="text.secondary">DATOS DE ACCESO</Typography>
          </Divider>

          <TextField
            label="Correo electrónico (opcional)"
            type="email"
            value={datos.correo}
            onChange={(e) => set('correo', e.target.value)}
            error={!!errores.correo}
            helperText={errores.correo}
            fullWidth
          />
          <TextField
            label="Contraseña"
            type="password"
            value={datos.contrasena}
            onChange={(e) => set('contrasena', e.target.value)}
            error={!!errores.contrasena}
            helperText={errores.contrasena || 'Mínimo 6 caracteres'}
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onCerrar}>Cancelar</Button>
        <Button
          variant="contained"
          color="warning"
          onClick={enviar}
          size="large"
          sx={{ color: '#fff' }}
        >
          Crear mi cuenta
        </Button>
      </DialogActions>
    </Dialog>
  );
}
